
import { MapPin, ThumbsUp } from "lucide-react";
import { useTheme } from "@/contexts/ThemeContext";

export default function Logo() {
  const { theme } = useTheme();
  
  return (
    <div className="flex items-center gap-2">
      <div className="relative">
        <MapPin className="h-9 w-9 text-primary" />
        <div className="absolute -right-1 -top-1">
          <ThumbsUp className="h-[18px] w-[18px] text-primary" />
        </div>
      </div>
      <span className="text-2xl font-bold">
        <span>Good</span>
        <span className="text-primary">Vote</span>
        
      </span>
    </div>
  );
}
